import { METHOD } from './method'

export const API_PRODUCT_TYPE = {
    LIST: {
        api: '/v1/dashboard-admin/type/list',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/type',
        method: METHOD.DELETE,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/type/product',
        method: METHOD.GET,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/type',
        method: METHOD.GET,
    },
    CREATE: {
        api: '/v1/dashboard-admin/type',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/type',
        method: METHOD.PUT,
    },
}
